import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#383838',
  fontWeight: 700,
  fontSize: 24,
  textAlign: 'center'
}

export const sxTypographyTitleRecovery: SxProps = {

  color: '#4C4C4C',
  fontWeight: 700,
  fontSize: 24,
  textAlign: 'center'
}

export const sxTypographyTitleLeft: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#383838',
  fontWeight: 700,
  fontSize: 24,
  textAlign: 'start'
}

export const sxTypographySubTitle: SxProps = {
  marginBottom: '24px',
  textAlign: 'center'
};

export const sxButtonContained: SxProps = {
  borderRadius: 80,
  padding: '12px 32px',
  height: '44px',
  width: '350px',
 '@media (max-width: 899px)': {
    width: '100%',
  },
};

export const sxTextButtonCapitalize: SxProps = {
  textTransform: 'none'
};

export const sxTextButton: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 16
};

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px'
}

export const sxButtonLogin: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
}

export const sxButtonOptionRecovery: SxProps = {
  borderRadius: '80px',
  padding: '12px 32px',
  width: '100%'
}

export const sxButtonText: SxProps = {
  textDecoration: 'underline',
  textTransform: 'none',
  fontFamily: 'Unimed-Sans',
  fontWeight: 600,
  paddingLeft: 0,
  color: '#00834F',
  '&:hover': {
    color: '#164029',
  },
  '&:focus': {
    color: 'rgba(0, 0, 0, 0.08)',
  }
}


export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxValidationMessage: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#D84141',
  fontSize: 12
}
